import React from 'react';

import * as styles from './DepartmentCard.styles';

export interface DepartmentCardImage {
  src: string;
  width: number;
}

export interface DepartmentCardProps {
  href: string;
  images: DepartmentCardImage[];
  title: string;
}

// The card is a fixed 175px wide, whatever the screen.
const IMAGE_SIZES = '175px';

export const DepartmentCard = ({ href, images, title }: DepartmentCardProps) => (
  <a css={styles.card} href={href}>
    <span css={styles.media}>
      {images.length > 0 && (
        <img
          alt=""
          css={styles.image}
          loading="lazy"
          sizes={IMAGE_SIZES}
          src={images[0]!.src}
          srcSet={images.map(({ src, width }) => `${src} ${width}w`).join(', ')}
        />
      )}
    </span>
    <span css={styles.title}>{title}</span>
  </a>
);
